import API from '../api/index';
import IBono from '../types/Bono';
import { IBonoPacientePayload } from '../types/BonoPaciente';

const createBono = (data: IBono) => API.post('/bono', data);
const updateBono = (_id: string, data: IBono) => API.put(`/bono/${_id}`, data);
const updateBonoActivo = (_id: string, payload: { activo: boolean; userId: string }) => API.patch(`/bono/${_id}/activo`, payload);

const getBonosPacientes = (_id: string) => API.get(`/bonos-pacientes${_id}`);
const createBonoPaciente = (data: IBonoPacientePayload) => API.post('/bonos-pacientes', data);
const updateBonoPaciente = (_id: string, data: IBonoPacientePayload) => API.put(`/bonos-pacientes/${_id}`, data);
const getFacturasBono = (_id: string) => API.get(`/bonos-pacientes/facturas/${_id}`);

const compartirBono = (_id: string, pacientesIds: string[]) => API.post(`/bonos-pacientes/compartir/${_id}`, { pacientesIds });
const descompartirBono = (_id: string, pacienteId: string) => API.post(`/bonos-pacientes/descompartir/${_id}`, { pacienteId });

const anularBono = (_id: string, estadoEsperado?: string) => API.patch(`/bonos-pacientes/anular/${_id}`, { estadoEsperado });
const cambiarEntidadBono = (_id: string, data: { userId: string, entidadNuevaId: string | null, estadoEsperado?: string }) => API.patch(`/bonos-pacientes/${_id}/cambiar-entidad`, data);

const getDetalleBono = (_id: string) => API.get(`/bonos-pacientes/detalle/${_id}`); 

const BonoService = {
    createBono,
    updateBono,
    updateBonoActivo,
    getBonosPacientes,
    createBonoPaciente,
    updateBonoPaciente,
    getFacturasBono,
    compartirBono,
    descompartirBono,
    anularBono,
    cambiarEntidadBono,
    getDetalleBono
};

export default BonoService;